import { Application } from "../Application/Application.js";
const application = new Application();
window.application = application;

const loader = document.querySelector('.loader');
const body = document.querySelector('body');

if (document.querySelectorAll('.loader').length) {
	body.classList.add('loading');

	window.addEventListener('load', () => {
		setTimeout(() => {
			loader.classList.add('ready');
			body.classList.remove('loading');
		}, 400);
		setTimeout(() => {
			if (animItems.length > 0) {
				animOnScroll();
			}
			if (gallery) {
				gallerySlideNext();
			}
			// Meta Pixel Code
			var script = document.createElement("script");
			var noscript = document.createElement("noscript");
			script.innerHTML = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '5479750995481337');
				fbq('track', 'PageView');
			`;
			noscript.innerHTML = `
				img(height='1' width='1' style='display:none' src='https://www.facebook.com/tr?id=5479750995481337&ev=PageView&noscript=1')
			`;
			document.getElementsByTagName('head')[0].appendChild(script);
			document.getElementsByTagName('head')[0].appendChild(noscript);
		}, 800);
	});
}

const animItems = document.querySelectorAll('.animated-page .anim-item');
function animOnScroll(params) {
	for (let index = 0; index < animItems.length; index++) {
		const animItem = animItems[index];
		const animItemHeight = animItem.offsetHeight;
		const animItemOffsetTop = offset(animItem).top;
		const animStart = 3;

		let animItemPointY = window.innerHeight - animItemHeight / animStart;

		if (animItemHeight > window.innerHeight) {
			animItemPointY = window.innerHeight - window.innerHeight / animStart;
		}

		if (pageYOffset > animItemOffsetTop - animItemPointY && pageYOffset < animItemOffsetTop + animItemHeight) {
			animItem.classList.add('active');
		} else {
			if (!animItem.classList.contains('anim-item--no-hide')) {
				animItem.classList.remove('active');
			}
		}
	}
};

const gallery = document.querySelector('.gallery');
function gallerySlideNext(params) {
	const galleryItemHeight = gallery.offsetHeight;
	const galleryItemOffsetTop = offset(gallery).top;
	const galleryStart = 3;

	let galleryItemPointY = window.innerHeight - galleryItemHeight / galleryStart;

	if (galleryItemHeight > window.innerHeight) {
		galleryItemPointY = window.innerHeight - window.innerHeight / galleryStart;
	}

	if (pageYOffset > galleryItemOffsetTop - galleryItemPointY && pageYOffset < galleryItemOffsetTop + galleryItemHeight && !gallery.classList.contains('active')) {
		gallerySlider.slideNext();
		gallery.classList.add('active');
	}
};

function offset(el) {
	const rect = el.getBoundingClientRect(),
		scrollTop = window.pageYOffset || document.documentElement.scrollTop,
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
};

$(window).scroll(function () {
	if ($(this).scrollTop() > 0) {
		$(".header").addClass("scrolled");
	} else {
		$(".header").removeClass("scrolled");
	};

	setBodyPadding();

	if (animItems.length > 0) {
		animOnScroll();
	}
	if (gallery) {
		gallerySlideNext();
	}

	if ($(".program__nav").length) {
		setProgramNavTop();
		checkProgramNavSticky();
		setProgramItemAdditional();
		checkProgramNavScrolled();
	};

	if ($(".application-form__nav").length) {
		setApplicationFormNav()
	};
});

$(window).resize(function () {
	setBodyPadding();

	if (window.matchMedia("(min-width: 1024px)").matches) {
		if ($(".main-nav__menu").hasClass("active")) {
			$(".main-nav__toggler").removeClass("active");
			$(".main-nav__menu").removeClass("active");
		}
		$(".main-nav__menu").removeAttr("style");
	}

	if ($(".program__nav").length) {
		setProgramNavTop();
		checkProgramNavSticky();
		setProgramItemAdditional();
		checkProgramNavScrolled();
	};

	if ($(".application-form__nav").length) {
		setApplicationFormNav()
	};
});

function setBodyPadding() {
	$("body").css("padding-top", $(".header").outerHeight());
};

setBodyPadding();

$('a[href^="#"]').on("click", function () {
	let elementClick = $(this).attr("href").replace(/.*#/, '');
	if (elementClick && $('a[name=' + elementClick + ']').length) {
		let destination = $('a[name=' + elementClick + ']').offset().top - $(window).innerHeight() / 8;
		console.log(destination);
		$('html, body').animate({ scrollTop: destination }, 1100);
	}
});

$(document).ready(function () {
	if (window.location.hash.match(/#.+/)) {
		let elementClick = window.location.hash.replace(/.*#/, '');
		if (elementClick && $('a[name=' + elementClick + ']').length) {
			let destination = $('a[name=' + elementClick + ']').offset().top - $(window).innerHeight() / 8;
			$(window).scrollTop(destination);
		}
	}
});

function setProgramNavTop() {
	$(".program__nav").css("top", $(".header").outerHeight());
};

function checkProgramNavSticky() {
	var programNavRect = document.querySelector(".program__nav").getBoundingClientRect();
	if (programNavRect.top <= $(".header").outerHeight()) {
		$(".program__nav").addClass("scrolled");
	} else {
		$(".program__nav").removeClass("scrolled");
	}
};

function checkProgramNavScrolled() {
	if ($(".program-nav__list").innerWidth() >= $(window).innerWidth()) {
		$(".program-nav__chevron").show();
	} else {
		$(".program-nav__chevron").hide();
	}
};

function scrollToActiveProgramNav(elem) {
	$(".program-nav__item-btn").removeClass("active");
	$(elem).addClass("active");

	if ($(elem).attr('data-type')) {
		let dt = $(elem).attr('data-type');
		$('li.program-table__item').each(function () {
			if ($(this).find('.program-item__tags-item[data-type=' + dt + ']').length)
				$(this).slideDown();
			else
				$(this).slideUp();
		});
	}
	else {
		$('li.program-table__item').slideDown();
	}

	if ($(elem).offset().left + $(elem).innerWidth() > $(".container").offset().left + $(".container").innerWidth() || $(elem).offset().left < $(".container").offset().left) {
		$(".program-nav__list").animate({ scrollLeft: $(elem).offset().left + $(elem).outerWidth(true) / 2 + $('.program-nav__list').scrollLeft() - $('.program-nav__list').outerWidth() / 2 }, 400);
	}

	let destination = $('.program').offset().top - $(".header").outerHeight() + parseInt($(".program").css("padding-top"));
	$('html, body').animate({ scrollTop: destination }, 500);
};

$(".program-nav__item-btn").on("click", function () {
	scrollToActiveProgramNav(this);
});

function setProgramItemAdditional() {
	if (window.matchMedia("(min-width: 1024px)").matches) {
		$(".program-item__additional").each(function () {
			if ($(this).outerHeight() <= $(window).innerHeight() - ($(".header").outerHeight() + $(".program__nav").outerHeight() + parseInt($(".program-item__content").css("padding-top")) * 2)) {
				$(this).addClass("sticky");
				$(this).css("top", $(".header").outerHeight() + $(".program__nav").outerHeight() + parseInt($(".program-item__content").css("padding-top")));
			} else {
				$(this).removeClass("sticky");
				$(this).removeAttr("style");
			}
		})
	}
};

if ($(".program__nav").length) {
	setProgramNavTop();
	checkProgramNavSticky();
	setProgramItemAdditional();
	checkProgramNavScrolled();
};

$(".main-nav__toggler").on("click", function () {
	$(this).toggleClass("active");
	$(".main-nav__menu").fadeToggle();
	$(".main-nav__menu").toggleClass("active");
});

$(".condition__payment-toggler").on("click", function () {
	$(".condition__payment-info").slideToggle();
});

var gallerySlider = new Swiper('.gallery__container', {
	slidesPerView: 'auto',
	loop: true,
	centeredSlides: true,
	spaceBetween: 16,
	navigation: {
		nextEl: '.gallery__nav--next',
		prevEl: '.gallery__nav--prev'
	},
	pagination: {
		el: '.gallery__pagination-container',
		clickable: true,
		bulletElement: "button type='button'",
		bulletClass: 'gallery__pagination-bullet',
		bulletActiveClass: 'gallery__pagination-bullet--active',
	},
	breakpoints: {
		768: {
			spaceBetween: 24
		},
		1280: {
			spaceBetween: 32
		},
		1360: {
			spaceBetween: 40
		}
	}
});

$(".program-item__certificate-btn").on("click", function () {
	$(this).siblings(".program-item__certificate-info").fadeToggle();
});

$(".program-item__certificate-info-close").on("click", function () {
	$(this).parent(".program-item__certificate-info").fadeOut();
});

$(document).on("click", function (e) {
	if ($(".program-item__certificate-info").is(":visible")) {
		var callbackPopup = $(".program-item__certificate-info, .program-item__certificate-btn")
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".program-item__certificate-info").fadeOut();
		};
	}
});

$(".program-item__full-description-more").on("click", function () {
	$(this).text(function (i, v) {
		return v === 'Смотреть подробное описание' ? 'Скрыть подробное описание' : 'Смотреть подробное описание'
	});
	$(this).siblings(".program-item__full-description-text").slideToggle();
});

$(".application-types__item-input").on("change", function () {
	if ($(".application-types__item-input--aud").is(":checked")) {
		$(".application__form--online").hide();
		$(".application__form--aud").fadeIn();
		$(".application__teaser-price--online").hide();
		$(".application__teaser-price--aud").fadeIn();
	}

	if ($(".application-types__item-input--online").is(":checked")) {
		$(".application__form--aud").hide();
		$(".application__form--online").fadeIn();
		$(".application__teaser-price--aud").hide();
		$(".application__teaser-price--online").fadeIn();
	}
});

function setApplicationFormNav() {
	$(".application-form__nav").css("top", $(".header").outerHeight());
};

if ($(".application-form__nav").length) {
	setApplicationFormNav()
};

$(".application-finish__participant-input").on("change", function () {
	if ($(this).closest(".application-finish__participant-list").find(".application-finish__participant-input--person").is(":checked")) {
		$(this).closest(".application-finish__participant").siblings(".application-finish__company").slideUp();
	}

	if ($(this).closest(".application-finish__participant-list").find(".application-finish__participant-input--company").is(":checked")) {
		$(this).closest(".application-finish__participant").siblings(".application-finish__company").slideDown();
	}
});

function calcSum(form) {
	$.ajax({
		url: "/ajax.php?mid=51",
		type: 'POST',
		data: form.serialize() + '&action=calcSum',
		dataType: "json",
		success: function (res) {
			console.log(res);
			let rs = form.find('.application-finish__summary-content');
			rs.html('');
			rs.append('<div class="application-finish__summary-row"></div>')
			rs.children().last()
				.append('<span class="application-finish__summary-item">Оргвзнос участника:</span>')
				.append('<span class="application-finish__summary-item">' + res.mainSum + ' руб.</span>');
			if (res.discounts.length) {
				let d = res.discounts[0];
				let name = d.name + (d.mode == '%' ? ' ' + d.amount + '%' : '');
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
					.append('<span class="application-finish__summary-item">' + name + ':</span>')
					.append('<span class="application-finish__summary-item">' + d.sum + ' руб.</span>');
			}

			if (res.sputSum) {
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
					.append('<span class="application-finish__summary-item">Программы спутники:</span>')
					.append('<span class="application-finish__summary-item">' + res.sputSum + ' руб.</span>');
			}

			if (res.optsSum) {
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
					.append('<span class="application-finish__summary-item">Теплоходная прогулка:</span>')
					.append('<span class="application-finish__summary-item">' + res.optsSum + ' руб.</span>');
			}

			if (res.mkSum) {
				rs.append('<div class="application-finish__summary-row"></div>')
				rs.children().last()
					.append('<span class="application-finish__summary-item">Удостоверения за мастер-классы:</span>')
					.append('<span class="application-finish__summary-item">' + res.mkSum + ' руб.</span>');
			}

			rs.append('<div class="application-finish__summary-row"></div>')
			rs.children().last()
				.append('<span class="application-finish__summary-item"><strong>Итого</strong></span>')
				.append('<span class="application-finish__summary-item"><strong>' + res.sum + ' руб.</strong></span>');
		},
		error: function (err) { }
	});
};

function syncInput(el) {
	let form = $(el[0].form);
	let targetForm;
	if (form.hasClass('application__form--aud'))
		targetForm = $('.application__form--online');
	else
		targetForm = $('.application__form--aud');

	let name = el.attr('name');
	let type;
	if (el.prop("tagName") == 'SELECT')
		type = 'select';
	else
		type = el.attr('type');

	let targetInput = targetForm.find('input[name = ' + name + ']');

	if (type == 'select') {
		targetInput = targetForm.find('select[name = ' + name + ']');
		targetInput.val(el.val());
	}
	else if (type == 'checkbox') {
		targetInput.prop('checked', el.prop('checked'));
	}
	else if (type == 'radio') {
		targetInput.filter('[value=' + el.val() + ']').prop('checked', true);
	}
	else {
		targetInput.val(el.val());
	}

}

function orderMk(parent, id) {
	let orderId = $('.trans-personal__content input[name=order_id]').val();
	let clientId = $('.trans-personal__content input[name=client_id]').val();
	let secret = $('.trans-personal__content input[name=secret]').val();

	$.ajax({
		url: "/ajax.php?mid=51",
		type: 'POST',
		data: { action: 'order_mk', orderId: orderId, clientId: clientId, secret: secret, id: id },
		dataType: "json",
		async: false,
		success: function (res) {
			if (res.success) {
				parent.attr('href', res.payURL);
				window.open(res.payURL, '_blank');
			}
			else {
				alert(res.error);
			}
		},
		error: function (err) { }
	});
}

$('.order_mk_button').on("click", function () {
	let el = $(this);
	orderMk(el, el.attr('data-id'));
});

$('.application__form').on('change', 'input, select', function () {
	calcSum($(this.form));
	syncInput($(this));
});

calcSum($('.application__form--aud'));
calcSum($('.application__form--online'));

if (window.location.hash == '#online') {
	$('.application-types__item-input--online').prop('checked', true).trigger('change');
}

function setcookie(name, value, expires, path, domain, secure) {	// Send a cookie
	//
	// +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)

	expires instanceof Date ? expires = expires.toGMTString() : typeof (expires) == 'number' && (expires = (new Date(+(new Date) + expires * 1e3)).toGMTString());
	var r = [name + "=" + escape(value)], s, i;
	for (i in s = { expires: expires, path: path, domain: domain }) {
		s[i] && r.push(i + "=" + s[i]);
	}
	return secure && r.push("secure"), document.cookie = r.join(";"), true;
};
// возвращает cookie если есть или undefined
function getcookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	))
	return matches ? decodeURIComponent(matches[1]) : undefined
};
console.log('test');
